"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
// import { useToolsState } from '../../hooks/useToolsState';
const molecules_1 = require("../../molecules");
const providers_1 = require("../../providers");
const ANIMATION_TIME = 700;
function LabelsAnnotationsPanel({ isOpen, onClose, buttonRef, }) {
    var _a;
    const [selectedTab, setSelectedTab] = (0, react_1.useState)(null);
    const containerRef = (0, react_1.useRef)(null);
    const { t } = (0, i18n_1.useTranslation)();
    const state = (0, providers_1.useToolsStateContext)();
    const [isFullscreen, setIsFullScreen] = (0, react_1.useState)(false);
    (0, ui_1.useOutsideClick)(containerRef, onClose, [buttonRef], {
        active: true,
        stopPropagation: true,
    });
    if (!state) {
        return null;
    }
    const { labelsState, stickiesState: { stickies }, } = state;
    const hasLabels = ((_a = labelsState === null || labelsState === void 0 ? void 0 : labelsState.labels) === null || _a === void 0 ? void 0 : _a.length) > 0;
    const hasStickies = (stickies === null || stickies === void 0 ? void 0 : stickies.length) > 0;
    const hasBothTabs = hasLabels && hasStickies;
    if (!selectedTab) {
        if (hasLabels)
            setSelectedTab('labels');
        else if (hasStickies)
            setSelectedTab('annotations');
    }
    const onTabClick = (tab) => () => {
        setSelectedTab(tab);
    };
    const handleEnter = () => {
        document.body.style.overflow = 'hidden';
    };
    const handleExited = () => {
        document.body.style.overflow = '';
    };
    const onFullScreenClick = (newState) => {
        setIsFullScreen(newState);
    };
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isOpen, timeout: 700, classNames: "slide", unmountOnExit: true, appear: true, onEnter: handleEnter, onExited: handleExited, "data-e2e": 'LabelsAnnotationsPanel_CSSTransition', children: (0, jsx_runtime_1.jsx)(Wrapper, { ref: containerRef, "data-e2e": 'LabelsAnnotationsPanel_Wrapper', children: (0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'LabelsAnnotationsPanel_Container', children: [(0, jsx_runtime_1.jsxs)(Header, { "data-e2e": 'LabelsAnnotationsPanel_Header', children: [(0, jsx_runtime_1.jsxs)(TabsContainer, { hasBothTabs: hasBothTabs, "data-e2e": 'LabelsAnnotationsPanel_TabsContainer', children: [hasLabels && ((0, jsx_runtime_1.jsx)(Tab, { isSelected: selectedTab === 'labels', hasBothTabs: hasBothTabs, onClick: onTabClick('labels'), "data-e2e": 'LabelsAnnotationsPanel_Tab', children: t(i18n_1.Strings.toolkit.tools.labels) })), hasStickies && ((0, jsx_runtime_1.jsx)(Tab, { isSelected: selectedTab === 'annotations', hasBothTabs: hasBothTabs, onClick: onTabClick('annotations'), "data-e2e": 'LabelsAnnotationsPanel_Tab', children: t(i18n_1.Strings.screens.annotations) }))] }), (0, jsx_runtime_1.jsx)(CloseButton, { onClick: onClose, "data-e2e": 'LabelsAnnotationsPanel_CloseButton' })] }), (0, jsx_runtime_1.jsxs)(ItemsContainer, { isFullscreen: isFullscreen, "data-e2e": 'LabelsAnnotationsPanel_ItemsContainer', children: [selectedTab === 'labels' && ((0, jsx_runtime_1.jsx)(molecules_1.LabelsItems, { onClose: onClose, labelsState: labelsState, "data-e2e": 'LabelsAnnotationsPanel_LabelsItems' })), selectedTab === 'annotations' && ((0, jsx_runtime_1.jsx)(molecules_1.AnnotationsItems, { isFullscreen: isFullscreen, stickies: stickies, onFullscreen: onFullScreenClick, "data-e2e": 'LabelsAnnotationsPanel_AnnotationsItems' }))] })] }) }) }));
}
exports.default = LabelsAnnotationsPanel;
const Wrapper = styled_components_1.default.div `
  position: absolute;
  width: 100%;
  height: 50vh;
  left: 0;
  bottom: 0;
  top: auto;
  z-index: 12;

  &.slide-enter {
    transform: translateY(100%);
  }
  &.slide-enter-active {
    transform: translateY(0);
    transition: transform ${ANIMATION_TIME}ms ease-in-out;
  }
  &.slide-exit {
    transform: translateY(0);
  }
  &.slide-exit-active {
    transform: translateY(100%);
    transition: transform ${ANIMATION_TIME}ms ease-in-out;
  }
`;
const Container = styled_components_1.default.div `
  width: 100%;
  max-width: 899px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 8px;
  padding-right: 3px;
  border-radius: 8px 8px 0 0;
  background-color: ${({ theme }) => theme.grasshopper.background};
  box-sizing: border-box;
`;
const Header = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const CloseButton = (0, styled_components_1.default)(ui_1.CloseForGrasshopper) `
  width: 44px;
  height: 44px;
  margin: 0 8px;
`;
const TabsContainer = styled_components_1.default.div `
  display: flex;
  justify-content: flex-start;
  width: fit-content;
  padding-top: 8px;
  margin-bottom: 10px;

  ${({ theme, hasBothTabs }) => hasBothTabs &&
    (0, styled_components_1.css) `
      border-bottom: 1px solid ${theme.grasshopper.borders.grey};
    `}
`;
// Overflow fix for Safari
const ItemsContainer = styled_components_1.default.div `
  flex: 1;
  overflow: ${({ isFullscreen }) => (isFullscreen ? 'visible' : 'hidden')};
`;
const Tab = styled_components_1.default.div `
  cursor: pointer;
  white-space: nowrap;
  font-weight: 400;
  font-size: 20px;
  padding: 8px;
  padding-right: 16px;
  padding-left: 16px;

  ${({ theme, isSelected, hasBothTabs }) => hasBothTabs &&
    isSelected &&
    (0, styled_components_1.css) `
      border-bottom: 4px solid ${theme.grasshopper.borders.white};
    `}

  color: ${({ theme, isSelected }) => isSelected
    ? theme.grasshopper.text.white
    : theme.grasshopper.text.whiteSecondary};

  &:hover {
    ${({ theme, isSelected }) => !isSelected &&
    (0, styled_components_1.css) `
        color: ${theme.grasshopper.text.white};
      `}
  }
`;
